module.exports = __webpack_public_path__ + "img/qualite_acaplast_04.c1759685.jpg";